import { gridSize } from '@atlaskit/theme';
import styled from '@emotion/styled';

const verticalMarginSize = gridSize() * 6;

const columnWidth = gridSize() * 8;
const gutter = gridSize() * 2;

const wideContainerWidth = columnWidth * 6 + gutter * 5;
const narrowContainerWidth = columnWidth * 4 + gutter * 3;

type ContainerProps = {
    size?: string;
};

const Container = styled.div<ContainerProps>`
    margin: ${verticalMarginSize}px auto;
    text-align: center;
    width: ${({ size }) => (size === 'narrow' ? narrowContainerWidth : wideContainerWidth)}px;
`;

export default Container;
